export class DocumentTypeDto {
  documentTypeId?: number;
  titleFrancais: string;
  titleAnglais: string;
  pathImage: string;
  urlImage: string;
}
